import { fileUploadService, LogService } from "../../_services";
import { checkFileSize } from "../../_helpers/utility";

// type ListUploadStatus = "AllSuccess" | "PartialSuccess" | "Failed" | "Error";

// type FilePendingUpload = {
//     id: string | number,
//     file: File,
//     fileName: string,
//     fileExtension: string,
//     pathEndpoint: "File" | "Pdf" | "Image" | "Video" | "VideoCapture",
//     usageType: "ExhibitPhoto" | "ExhibitVideo" | "ExhibitShortVideo" | string, // For recording usage type of the file
//     [string]: any,
// }

// type UploadedFile = FilePendingUpload & {
//     uploadedOssUrl: string,
// }

// type UploadResponse = {
//     status: ListUploadStatus,
//     successfulList: UploadedFile,
//     failedList: FilePendingUpload,
// }

const LOG_PAGE_NAME = "FileUpload";

async function getStsToken() {
    return await fileUploadService
        .GetStsToken()
        .then((res) => res)
        .catch((err) => {
            LogService.LogFormErrorWithObj(
                {
                    PageName: LOG_PAGE_NAME,
                    SectionName: "GetStsToken",
                    Action: "GetStsToken",
                },
                {
                    ErrorName: err.name,
                    ErrorMessage: err.message,
                    ErrorStack: err.stack,
                }
            );
            throw err;
        });
}

async function uploadManipulator(client, headers, file, newOssFileName, isLargeFile, usageType, fileIdInQueue) {
    try {
        let uploadedOssUrl = "";

        if (isLargeFile) {
            const options = {
                headers,
                // 获取分片上传进度、断点和返回值。
                // progress: (p, cpt, res) => {
                //     console.log(p);
                // },
                // 设置并发上传的分片数量。
                parallel: 5,
                // 设置分片大小。默认值为1 MB，最小值为100 KB，最大值为5 GB。最后一个分片的大小允许小于100 KB。
                partSize: 1024 * 1024 * 10, // 10 MB
                // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
                // meta: { year: 2020, people: "test" },
                mime: "text/plain",
            };

            const res = await client
                .multipartUpload(newOssFileName, file, {
                    ...options,
                    // 设置上传回调。
                    // 如果不涉及回调服务器，请删除callback相关设置。
                    // callback: {
                    //     // 设置回调请求的服务器地址。
                    //     url: "http://examplebucket.aliyuncs.com:23450",
                    //     // 设置回调请求消息头中Host的值，即您的服务器配置Host的值。
                    //     host: "yourHost",
                    //     /* eslint no-template-curly-in-string: [0] */
                    //     // 设置发起回调时请求body的值。
                    //     body: "bucket=${bucket}&object=${object}&var1=${x:var1}",
                    //     // 设置发起回调请求的Content-Type。
                    //     contentType: "application/x-www-form-urlencoded",
                    //     customValue: {
                    //         // 设置发起回调请求的自定义参数。
                    //         var1: "value1",
                    //         var2: "value2",
                    //     },
                    // },
                })
                .catch((err) => {
                    LogService.LogFormErrorWithObj(
                        {
                            PageName: LOG_PAGE_NAME,
                            SectionName: "LargeFileClientUpload",
                            Action: "Upload",
                        },
                        {
                            FileIdInQueue: fileIdInQueue,
                            ErrorName: err.name,
                            ErrorMessage: err.message,
                            ErrorStack: err.stack,
                            FileUsageType: usageType,
                        }
                    );
                    throw err;
                });
            // console.log("Success Upload multipartUpload: ", res);
            uploadedOssUrl = `${process.env.VUE_APP_OSS_ORIGIN}${res.name}`;
        }

        if (!isLargeFile) {
            const res = await client.put(newOssFileName, file, { headers }).catch((err) => {
                LogService.LogFormErrorWithObj(
                    {
                        PageName: LOG_PAGE_NAME,
                        SectionName: "SmallFileClientUpload",
                        Action: "Upload",
                    },
                    {
                        FileIdInQueue: fileIdInQueue,
                        ErrorName: err.name,
                        ErrorMessage: err.message,
                        ErrorStack: err.stack,
                        FileUsageType: usageType,
                    }
                );
                throw err;
            });
            // console.log("Success Upload put: ", res);
            uploadedOssUrl = `${process.env.VUE_APP_OSS_ORIGIN}${res.name}`;
        }

        return uploadedOssUrl;
    } catch (error) {
        throw error;
    }
}

function checkIsValidPendingUpload(data) {
    return (
        data &&
        data.id &&
        data.file &&
        data.file instanceof Blob &&
        data.fileName &&
        data.pathEndpoint &&
        data.usageType &&
        data.fileExtension
    );
}

function mapDataToPendingUpload(data, listIndex) {
    return {
        ...data,
        ossEndpointPath: `${process.env.VUE_APP_OSS_UPLOAD_ENDPOINT}${data.pathEndpoint}/`,
        isLargeFile: checkFileSize(data.file, 100), // Is file size larger than 100MB
        listIndex: listIndex + 1,
    };
}

function mapDataToLogFormDataFormat(data) {
    return {
        id: data.id,
        fileSize: data.file?.size,
        fileName: data.fileName,
        usageType: data.usageType,
        fileExtension: data.fileExtension,
        ossEndpointPath: data.ossEndpointPath,
    };
}

const initialState = {
    filePendingUploadList: [], // type FilePendingUpload
    client: null,
    isUploading: false,
    noOfUploadedFile: 0,
    totalNoOfUploadedFile: 0,
    expirationTime: null,
};

const getters = {
    progress: (state) => {
        return {
            isUploading: state.isUploading,
            noOfUploadedFile: state.noOfUploadedFile,
            total: state.totalNoOfUploadedFile,
        };
    },

    empCompanyId: (state, getters, rootState) => {
        // console.log("rootState.authentication?.user?.empCompanyId: ", rootState.authentication?.user?.empCompanyId);
        return rootState.authentication?.user?.empCompanyId ?? 0;
    },

    isExpired: (state) => {
        return state.expirationTime ? new Date().getTime() >= state.expirationTime.getTime() : false;
    },
};

const actions = {
    async refreshToken({ state, dispatch, getters, commit }, isForceRefresh = false) {
        if (!state.client) {
            await dispatch("initClient");

            return;
        }

        if (!isForceRefresh && !getters.isExpired) return;

        const newToken = await getStsToken();

        if (!newToken || !newToken.stsAccessKeyId || !newToken.stsAccessKeySecret || !newToken.stsSecurityToken) {
            commit("clearClient");
        }

        // TODO: Fix not immediate refresh
        commit("refreshTokenAndExpirationTime", {
            accessKeyId: newToken.stsAccessKeyId,
            accessKeySecret: newToken.stsAccessKeySecret,
            stsToken: newToken.stsSecurityToken,
            expirationTime: new Date(newToken.expiration),
        });
    },

    async initClient({ commit }) {
        try {
            const credentials = await getStsToken();

            const client = new OSS({
                region: credentials.region,
                authorizationV4: true,
                accessKeyId: credentials.stsAccessKeyId,
                accessKeySecret: credentials.stsAccessKeySecret,
                stsToken: credentials.stsSecurityToken,
                refreshSTSTokenInterval: credentials.refreshEarlySeconds * 1000, // ms
                refreshSTSToken: async () => {
                    const data = await getStsToken();

                    if (!data || !data.stsAccessKeyId || !data.stsAccessKeySecret || !data.stsSecurityToken) {
                        commit("clearClient");
                        throw new Error("Failed to refresh STS token.");
                    }

                    return {
                        accessKeyId: data.stsAccessKeyId,
                        accessKeySecret: data.stsAccessKeySecret,
                        stsToken: data.stsSecurityToken,
                        expiration: data.expiration,
                    };
                },
                bucket: credentials.bucket,
                endpoint: credentials.endpoint,
                secure: true,
                timeout: 300000, // connect timeout: 5 minutes
            });

            commit("initClient", {
                client,
                expirationTime: new Date(credentials.expiration),
            });
        } catch (err) {
            LogService.LogFormErrorWithObj(
                {
                    PageName: LOG_PAGE_NAME,
                    SectionName: "InitClient",
                    Action: "InitClient",
                },
                {
                    ErrorName: err.name,
                    ErrorMessage: err.message,
                    ErrorStack: err.stack,
                }
            );

            console.error(err);
            commit("clearClient");
            throw err;
        }
    },

    addPendingFile({ commit }, payload) {
        if (!checkIsValidPendingUpload(payload)) {
            LogService.LogFormErrorWithObj(
                {
                    PageName: LOG_PAGE_NAME,
                    SectionName: "AddPendingFile",
                    Action: "ValidatingData",
                },
                {
                    ErrorMessage: "Invalid PendingUpload Data",
                    FileData: {
                        id: payload.id,
                        isFileExists: !!payload.file,
                        isFileDataTypeValid: payload.file ? payload.file instanceof Blob : false,
                        fileName: payload.fileName,
                        pathEndpoint: payload.pathEndpoint,
                        usageType: payload.usageType,
                        fileExtension: payload.fileExtension,
                        fileSize: payload.file && payload.file instanceof Blob ? payload.file.size : 0,
                    },
                }    
            );
            console.error("Invalid PendingUpload Data: ", payload);
            return;
        }

        commit("addPendingFile", payload);
        commit("refreshTotalNoOfUploadedFile");
    },

    addPendingFiles({ commit }, payload) {
        const filteredFiles = payload.filter((f) => {
            const isValid = checkIsValidPendingUpload(f);
            if (!isValid) {
                LogService.LogFormErrorWithObj(
                    {
                        PageName: LOG_PAGE_NAME,
                        SectionName: "AddPendingFiles",
                        Action: "ValidatingData",
                    },
                    {
                        ErrorMessage: "Invalid PendingUpload Data",
                        FileData: {
                            id: f.id,
                            isFileExists: !!f.file,
                            isFileDataTypeValid: f.file ? f.file instanceof Blob : false,
                            fileName: f.fileName,
                            pathEndpoint: f.pathEndpoint,
                            usageType: f.usageType,
                            fileExtension: f.fileExtension,
                            fileSize: f.file && f.file instanceof Blob ? f.file.size : 0,
                        },
                    }
                );
                console.error("Invalid PendingUpload Data: ", f);
            }
            return isValid;
        });
        if (!filteredFiles.length) return;

        commit("addPendingFiles", filteredFiles);
        commit("refreshTotalNoOfUploadedFile");
    },

    // : Promise<UploadResponse>
    async upload({ commit, state, dispatch, getters }, payload) {
        if (state.isUploading) return;

        return new Promise(async (resolve, reject) => {
            if (!state.filePendingUploadList.length) {
                resolve({
                    status: "AllSuccess",
                    successfulList: [],
                    failedList: [],
                });
            }

            await dispatch("refreshToken").catch((err) => {
                reject({
                    error: err,
                    failedList: state.filePendingUploadList,
                });
            });

            commit("startUpload");

            const successfulList = []; // type UploadedFile
            const failedList = [];
            const mappedList = state.filePendingUploadList.map(mapDataToPendingUpload);

            const client = state.client;
            const empCompanyId = getters.empCompanyId;

            if (!empCompanyId) {
                commit("endUpload");

                reject({
                    error: new Error("EmpCompanyId not found"),
                    failedList: state.filePendingUploadList,
                });
            }

            const totalNumberOfFiles = mappedList.length;
            if (totalNumberOfFiles === 0) {
                commit("endUpload");
                resolve({
                    status: "AllSuccess",
                    successfulList: [],
                    failedList: [],
                });
            }

            const logFormDataQuery = {
                FormId: empCompanyId,
                Action: "Upload",
                FormType: LOG_PAGE_NAME,
                ErrorLog: "",
            };
            LogService.LogFormDataWithObj(logFormDataQuery, mappedList.map(mapDataToLogFormDataFormat));

            payload.updateUploadProgress({
                noOfUploadedFile: state.noOfUploadedFile,
                total: totalNumberOfFiles,
            });

            const headers = {
                // 指定该Object被下载时的网页缓存行为。
                // "Cache-Control": "no-cache",
                // 指定该Object被下载时的名称。
                // "Content-Disposition": "example.txt",
                // 指定过期时间，单位为毫秒。
                // Expires: "1000",
                // 指定Object的存储类型。
                // "x-oss-storage-class": "Standard",
                // 指定Object标签，可同时设置多个标签。
                // "x-oss-tagging": "Tag1=1&Tag2=2",
                // 指定初始化分片上传时是否覆盖同名Object。此处设置为true，表示禁止覆盖同名Object。
                "x-oss-forbid-overwrite": "true",
            };

            for (let i = 0; i < mappedList.length; i++) {
                const data = mappedList[i];
                const fileIdInQueue = data.id;
                const file = data.file;

                const now = new Date();
                const paddedfullYear = now.getFullYear().toString().padStart(4, "0");
                const paddedfullMonth = (now.getMonth() + 1).toString().padStart(2, "0");
                const paddedfullDate = now.getDate().toString().padStart(2, "0");
                const paddedfullHours = now.getHours().toString().padStart(2, "0");
                const paddedfullMinutes = now.getMinutes().toString().padStart(2, "0");
                const paddedfullSeconds = now.getSeconds().toString().padStart(2, "0");
                const paddedfullMilliseconds = now.getMilliseconds().toString().padStart(3, "0");
                const formattedDate = `${paddedfullYear}${paddedfullMonth}${paddedfullDate}${paddedfullHours}${paddedfullMinutes}${paddedfullSeconds}${paddedfullMilliseconds}`;
                const newOssFileName = `${data.ossEndpointPath}${empCompanyId}_${formattedDate}_${i}.${data.fileExtension}`;

                let uploadedOssUrl = "";

                try {
                    uploadedOssUrl = await uploadManipulator(
                        client,
                        headers,
                        file,
                        newOssFileName,
                        data.isLargeFile,
                        data.usageType,
                        fileIdInQueue
                    );
                } catch (err) {
                    // Retry when invalid token
                    if (err.code === "InvalidAccessKeyId") {
                        try {
                            await dispatch("refreshToken", true);

                            uploadedOssUrl = await uploadManipulator(
                                client,
                                headers,
                                file,
                                newOssFileName,
                                data.isLargeFile,
                                data.usageType,
                                fileIdInQueue
                            );
                        } catch (e) {
                            LogService.LogFormErrorWithObj(
                                {
                                    PageName: LOG_PAGE_NAME,
                                    SectionName: "Upload",
                                    Action: "TokenExpiredRetry",
                                },
                                {
                                    FileIdInQueue: fileIdInQueue,
                                    ErrorName: e.name,
                                    ErrorMessage: e.message,
                                    ErrorStack: e.stack
                                }
                            );

                            console.error("Failed Upload: ", err);
                            console.error("Failed Upload and Retry: ", e);
                        }
                    } else {
                        LogService.LogFormErrorWithObj(
                            {
                                PageName: LOG_PAGE_NAME,
                                SectionName: "Upload",
                                Action: "Upload",
                            },
                            {
                                FileIdInQueue: fileIdInQueue,
                                ErrorName: err.name,
                                ErrorMessage: err.message,
                                ErrorStack: err.stack
                            }
                        );

                        console.error("Failed Upload: ", err);
                    }
                }

                if (uploadedOssUrl) {
                    successfulList.push({
                        ...data,
                        uploadedOssUrl,
                    });

                    commit("incrementUploadProgress");

                    payload.updateUploadProgress({
                        noOfUploadedFile: state.noOfUploadedFile,
                        total: totalNumberOfFiles,
                    });
                } else {
                    failedList.push({
                        ...data,
                    });
                }
            }

            commit("endUpload");

            // type ListUploadStatus
            const status =
                successfulList.length > 0 && failedList.length === 0
                    ? "AllSuccess"
                    : successfulList.length > 0 && failedList.length > 0
                    ? "PartialSuccess"
                    : "Failed";

            resolve({
                status,
                successfulList,
                failedList,
            });
        });
    },

    async addPendingFilesAndUpload({ state, dispatch }, payload) {
        if (state.isUploading) return;

        try {
            dispatch("addPendingFiles", payload.pendingFiles);

            if (state.filePendingUploadList.length === 0) {
                return {
                    status: "AllSuccess",
                    successfulList: [],
                    failedList: [],
                };
            }

            return await dispatch("upload", { updateUploadProgress: payload.updateUploadProgress });
        } catch (error) {
            console.error("addPendingFilesAndUpload: ", error);
            return {
                status: "Error",
                successfulList: [],
                failedList: payload.pendingFiles,
                errorMessage: error?.message || error.error?.message,
            };
        }
    }
};

const mutations = {
    initClient(state, { client, expirationTime }) {
        state.client = client;
        state.expirationTime = expirationTime;
    },

    refreshTokenAndExpirationTime(state, { accessKeyId, accessKeySecret, stsToken, expirationTime }) {
        state.client.options.accessKeyId = accessKeyId;
        state.client.options.accessKeySecret = accessKeySecret;
        state.client.options.stsToken = stsToken;
        state.expirationTime = expirationTime;
    },

    clearClient(state) {
        state.client = null;
    },

    addPendingFile(state, file) {
        state.filePendingUploadList.push(file);
    },

    addPendingFiles(state, files) {
        state.filePendingUploadList = state.filePendingUploadList.concat(files);
    },

    removePendingFile(state, { index }) {
        state.filePendingUploadList = state.filePendingUploadList.filter((f, i) => i !== index);
    },

    updatePendingFile(state, { file, index }) {
        state.filePendingUploadList[index] = file;
    },

    startUpload(state) {
        state.isUploading = true;
        state.noOfUploadedFile = 0;
    },

    endUpload(state) {
        state.filePendingUploadList = [];
        state.isUploading = false;
        state.noOfUploadedFile = 0;
    },

    incrementUploadProgress(state) {
        state.noOfUploadedFile += 1;
    },

    refreshTotalNoOfUploadedFile(state) {
        state.totalNoOfUploadedFile = state.filePendingUploadList.length;
    },

    // setUploadProgress(state, progress) {
    //     state.noOfUploadedFile = progress;
    // },

    // updateIsUploading(state, isUploading) {
    //     state.isUploading = isUploading;
    // },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};
